<template>
    <div class="row mx-0 align-items-center justify-content-between p-3 px-md-4 mb-0 border-bottom shadow-sm bg-navy">
        <h5 class="my-0 font-weight-normal color-w">
            <img :src="require('@/assets/login/Logo.png')" width="50px" height="auto" class="px-2" alt="Logo PDVx" />
            {{ appShortName }} </h5>
        <router-link to="/" class="btn btn-outline-light">
            <i class="fa fa-home"></i> Inicio
        </router-link>
    </div>
</template>

<script>
    export default {}
</script>

<style scoped src="@/assets/sass/bootstrap4.css"></style>
<style scoped>
    .btn-outline-light:hover {
        color: #212529 !important;
    }
</style>